export default __webpack_public_path__ + "static/media/companies-el-cronista.27137164.svg";